import { Request } from '@/classes/Request'
import { Util } from '@/modules/util'

export interface EnrollmentProviderConfig {
  hasTransit: boolean
  hasVericheck: boolean
  hasAuthorize: boolean
  environmentId?: number
  transitUrl?: string
  transitUrlWithManifest?: string
}

export interface EnrollmentFundingSourcesResponse {
  success: boolean
  accountExists: boolean
  familyUserId: number | null
  districtId: number
  fundingSources: TFundingSource[]
  providerConfig: EnrollmentProviderConfig
}

/**
 * Load the invited family's saved funding sources for the enrollment payment
 * screen. Token-authenticated (the invitation token resolves to the family
 * user), so it works on the public enrollment page with no session.
 * GET /api/enrollment/invitation/{token}/funding-sources
 */
export const enrollmentFundingSources = async (
  token: string
): Promise<EnrollmentFundingSourcesResponse> => {
  const response = await new Request().get(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/funding-sources`
  )
  return Util.Obj.keysToCamel(response.data) as EnrollmentFundingSourcesResponse
}
